import {
  Monitor, Heart, TrendingUp, Megaphone, Scale,
  Cog, Target, Users, Activity, MoreHorizontal,
  Building2, GraduationCap, Truck, ShoppingBag,
  Leaf, Utensils, Landmark, Zap, Shield, Globe,
} from "lucide-react";

export const FALLBACK_CATEGORIES = [
  "IT", "Healthcare", "Finance", "Marketing", "Legal",
  "Engineering", "Sales", "HR", "Operations",
];

// Keyword-based icon mapping — checked in order, first match wins.
// Each entry covers naming variations admins typically use.
const KEYWORD_ICON_MAP = [
  { keywords: ["information technology", "software", "tech", " it ", "digital", "computer", "data", "cyber", "cloud", "saas", "devops"], icon: Monitor },
  { keywords: ["health", "medical", "pharma", "clinical", "hospital", "biotech", "life science", "dental", "nursing"], icon: Heart },
  { keywords: ["finance", "financial", "banking", "bank", "insurance", "accounting", "invest", "wealth", "audit", "actuarial"], icon: TrendingUp },
  { keywords: ["market", "advertising", "media", "brand", "pr ", "public relation", "communication", "content", "seo", "social"], icon: Megaphone },
  { keywords: ["legal", "law", "compliance", "regulatory", "paralegal", "attorney", "counsel"], icon: Scale },
  { keywords: ["engineer", "manufactur", "industrial", "mechanical", "civil", "electrical", "chemical", "aerospace", "automotive"], icon: Cog },
  { keywords: ["construct", "real estate", "property", "estate", "building", "architecture", "infrastructure"], icon: Building2 },
  { keywords: ["sales", "retail", "commerce", "business development", "account manag", "revenue"], icon: Target },
  { keywords: ["hr ", "human resource", "people", "recruitment", "talent", "staffing", "payroll", "benefits"], icon: Users },
  { keywords: ["operation", "logistics", "supply chain", "warehouse", "transport", "procurement", "fulfillment"], icon: Truck },
  { keywords: ["educat", "learning", "training", "school", "university", "teach", "academic", "e-learning"], icon: GraduationCap },
  { keywords: ["food", "beverage", "restaurant", "hospitality", "tourism", "hotel", "catering"], icon: Utensils },
  { keywords: ["retail", "ecommerce", "fashion", "apparel", "consumer goods", "fmcg", "shopping"], icon: ShoppingBag },
  { keywords: ["government", "public sector", "municipal", "federal", "provincial", "nonprofit", "ngo"], icon: Landmark },
  { keywords: ["energy", "oil", "gas", "utility", "renewable", "solar", "wind", "mining"], icon: Zap },
  { keywords: ["security", "defence", "defense", "military", "intelligence", "investigation"], icon: Shield },
  { keywords: ["agri", "farm", "environmental", "nature", "green", "sustainability", "forestry"], icon: Leaf },
  { keywords: ["telecom", "network", "wireless", "internet service", "broadband", "isp"], icon: Globe },
];

export function getCategoryIcon(category) {
  const lower = " " + (category || "").toLowerCase() + " ";
  for (const { keywords, icon } of KEYWORD_ICON_MAP) {
    if (keywords.some((k) => lower.includes(k))) return icon;
  }
  return MoreHorizontal;
}

// Keep CATEGORY_ICONS for any legacy direct lookups elsewhere in the codebase
export const CATEGORY_ICONS = {
  IT:          Monitor,
  Healthcare:  Heart,
  Finance:     TrendingUp,
  Marketing:   Megaphone,
  Legal:       Scale,
  Engineering: Cog,
  Sales:       Target,
  HR:          Users,
  Operations:  Activity,
  Other:       MoreHorizontal,
};
